import React from 'react';
import styled from 'styled-components';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import Constants from '../../submodules/logictry_config/constants';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 2;
  background-color: white;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.65) 0px 1px 4px;
  padding: 2px 4px;
  img {
    height: 16px;
  }
`;

export default class PoweredByLogictry extends LogictryComponent {
  render() {
    const href = `https://logictry.com${Constants.urlWithoutOrigin}`;
    return (
      <a rel="noopener noreferrer" target="_blank" href={href}>
        <Wrapper>
          <img alt="logictry" src={Constants.Logo} />
        </Wrapper>
      </a>
    );
  }
}
